
import { Row, Card, Col, Form, Button, Badge, InputGroup } from "react-bootstrap";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import ErrorIcon from '@mui/icons-material/ErrorOutlined';
import Stack from 'react-bootstrap/Stack';
import { useState } from "react";
import { ACTIONS } from 'Containers/Private/Organization/OrganizationFormDataReducer';
import { displayErrors } from "Components/Messages/ErrorMessage";
import { isInObject } from "Utils/utilityFunctions";
import { applyDateSelectorFormat, isDateEmpty } from "Utils/utilityFunctions";
import { trimNumber, trimString } from "Utils/utilityFunctions";

export const FormInputDisplay = ({ fieldData, inputDispatch, ...props }) => {

    var horizontalForm = props.horizontalForm;
    var getColLabelSizes = props.getColLabelSizes;
    var hideLabel = props.hideLabel;

    var getVarValue = function (value) {
        if (typeof value === 'function') {
            return value();
        }
        else {
            return value;
        }
    };

    var getColSize = function (colType, size) {
        var horiz = horizontalForm;
        var colTypeVars = horiz[colType];

        if (colType in horiz) {
            if (size in colTypeVars) {
                return colTypeVars[size];
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    }

    var getPattern = function () {
        if (isInObject("pattern", props)) {
            return props.pattern;
        }
        else {
            return null;
        }
    }

    var getClasses = function () {
        if (isInObject("classes", props)) {
            return props.classes;
        }
        else {
            return null;
        }
    }

    var getRowClasses = function () {
        if (isInObject("rowClasses", props)) {
            return props.rowClasses;
        }
        else {
            return null;
        }
    }

    var getColLabelSizes = function (size) {
        var horiz = horizontalForm;

        if ('labelCols' in horiz) {
            var colTypeVars = horiz['labelCols'];
            if (size in colTypeVars) {
                return colTypeVars[size];
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    }


    var getFormFieldAlignment = function () {
        var horiz = horizontalForm;

        if ('is' in horiz) {
            if (horiz.is == true) {
                //console.log("horiz.is==true");
                return Row;
            }
            else {
                return Col;
            }
        }
        else {
            return Col;
        }
    }

    var displayLabel = function (fieldData, isHidden, getColLabelSizes, alignment, multi) {
        if (alignment == Row) {
            if (multi == true) {
                return (
                    <Col hidden={isHidden}
                        xs={getColLabelSizes('xs')}
                        sm={getColLabelSizes('sm')}
                        md={getColLabelSizes('md')}
                        lg={getColLabelSizes('lg')}
                        xl={getColLabelSizes('xl')}
                        xxl={getColLabelSizes('xxl')}
                    >
                        <legend>
                            {<span className="me-2">{fieldData.display.label}</span>}
                            {fieldData.validation.required ? '' : <Badge bg="optional">Optional</Badge>}
                        </legend>
                    </Col>
                );
            }
            else {
                return (
                    <Form.Label visuallyHidden={isHidden} column
                        xs={getColLabelSizes('xs')}
                        sm={getColLabelSizes('sm')}
                        md={getColLabelSizes('md')}
                        lg={getColLabelSizes('lg')}
                        xl={getColLabelSizes('xl')}
                        xxl={getColLabelSizes('xxl')}
                    >
                        {<span className="me-2">{fieldData.display.label}</span>}
                        {fieldData.validation.required ? '' : <Badge bg="optional">Optional</Badge>}
                    </Form.Label>
                );
            }
        }
        else {
            if (multi == true) {
                return (
                    <Row hidden={isHidden}
                        xs={getColLabelSizes('xs')}
                        sm={getColLabelSizes('sm')}
                        md={getColLabelSizes('md')}
                        lg={getColLabelSizes('lg')}
                        xl={getColLabelSizes('xl')}
                        xxl={getColLabelSizes('xxl')}
                    >
                        <legend>
                            {<span className="me-2">{fieldData.display.label}</span>}
                            {fieldData.validation.required ? '' : <Badge bg="optional">Optional</Badge>}
                        </legend>
                    </Row>
                );
            }
            else {
                return (
                    <Form.Label visuallyHidden={isHidden}
                        xs={getColLabelSizes('xs')}
                        sm={getColLabelSizes('sm')}
                        md={getColLabelSizes('md')}
                        lg={getColLabelSizes('lg')}
                        xl={getColLabelSizes('xl')}
                        xxl={getColLabelSizes('xxl')}
                    >
                         {<span className="me-2">{fieldData.display.label}</span>}
                        {fieldData.validation.required ? '' : /*<span className="optionalField"><br></br>optional</span>*/ <Badge bg="optional">Optional</Badge>}
                    </Form.Label>
                );
            }

        }

    };

    var displaySuccessMessages = (fieldData) => {
        //console.log(fieldData);
        return (
            <div>
                {fieldData.validation.successMsgs.length > 0 ? fieldData.validation.successMsgs.map((successText, index) =>
                    <Stack key={fieldData.name + "Success_" + index} direction="horizontal" gap={2} className="align-items-start">
                        <div id="successIcon"><ErrorIcon fontSize="small"></ErrorIcon></div>
                        <div>{successText}</div>
                    </Stack>

                ) : null}
            </div>
        );
    }

    /*var displayErrors = (fieldData) => {
        
        return (
            <div>
                {fieldData.validation.errors.length > 0 ? fieldData.validation.errors.map((errorText,index) => 
                    <Stack key={fieldData.name + "Errors_" + index} direction="horizontal" gap={2} className="align-items-start">
                        <div id="errorIcon"><ErrorIcon fontSize="small"></ErrorIcon></div>
                        <div>{errorText}</div>
                    </Stack>
                    
                ) : null}
            </div>
        );
    }*/

    const handleInputFileChange = (dispatch, e) => {
        //console.log("print out the text input change", e, e.target.attributes.id, e.target.value);
        //console.log(e.target.files);
        //console.log(e.target.file);
        /*if (pattern != null) {
            var emptyP = /^$/g;
            if (e.target.value.match(pattern) || e.target.value.match(emptyP)) {
                dispatch({
                    type: ACTIONS.TEXT_CHANGE,
                    value: e.target.value,
                    name: e.target.name
                });
            }
        }
        else {*/
            dispatch({
                type: ACTIONS.FILE_CHANGE,
                value: e.target.value,
                files: e.target.files,
                name: e.target.name
            });


    }

    const handleInputTextChange = (dispatch, e, pattern) => {
        //console.log("print out the text input change", e, e.target.attributes.id, e.target.value);
        //console.log(e);
        if (pattern != null) {
            var emptyP = /^$/g;
            if (e.target.value.match(pattern) || e.target.value.match(emptyP)) {
                dispatch({
                    type: ACTIONS.TEXT_CHANGE,
                    value: e.target.value,
                    name: e.target.name
                });
            }
        }
        else {
            dispatch({
                type: ACTIONS.TEXT_CHANGE,
                value: e.target.value,
                name: e.target.name
            });

        }

    }

    const handleInputTextAreaChange = (dispatch, e, pattern) => {
        //console.log("print out the text input change", e, e.target.attributes.id, e.target.value);
        //console.log(e);
        //console.log(e.target.maxLength);
        if (pattern != null) {
            var emptyP = /^$/g;
            if (e.target.value.match(pattern) || e.target.value.match(emptyP)) {
                dispatch({
                    type: ACTIONS.TEXT_AREA_CHANGE,
                    value: e.target.value,
                    maxLength: e.target.maxLength != null ? e.target.maxLength : 2000,
                    name: e.target.name
                });
            }
        }
        else {
            dispatch({
                type: ACTIONS.TEXT_AREA_CHANGE,
                value: e.target.value,
                maxLength: e.target.maxLength != null ? e.target.maxLength : 2000,
                name: e.target.name
            });

        }

    }

    const handleInputDateChange = (dispatch, e) => {
        //console.log("print out the date input change", e, e.target.attributes.id, e.target.value);
        //console.log(e);
        
            isDateEmpty(e);
            var val = e.target.value;
            //console.log(val);
            if(val != null)  {
                var split = val.split("-");
                if(split[0].length > 4) {
                    dispatch({
                        type: ACTIONS.DATE_CHANGE,
                        value: (val.substring(val.length-7,val.length)).padStart(10,"0"),
                        name: e.target.name
                    });

                }
                else {
                    
                    dispatch({
                        type: ACTIONS.DATE_CHANGE,
                        value: val,
                        name: e.target.name
                    });
                }
            } 
            else {
                
                dispatch({
                    type: ACTIONS.DATE_CHANGE,
                    value: '',
                    name: e.target.name
                });
            }
        
        
    }

    const handleInputSelectChange = (dispatch, e) => {
        //console.log("print out select change", e);
        dispatch({
            type: ACTIONS.SELECT_CHANGE,
            value: e.target.value,
            name: e.target.name
        })
    }

    const handleInputRadioChange = (dispatch, e) => {
        //console.log("print out radio change", e);
        //console.log(e.target.id);
        dispatch({
            type: ACTIONS.RADIO_CHANGE,
            value: e.target.value,
            name: e.target.name
        })
    }

    const handleInputCheckChange = (dispatch, e) => {
        //console.log("print out checkbox change", e);
        //console.log(e.target.id);
        dispatch({
            /*type: ACTIONS.CHECK_CHANGE,
            name: e.target.name,
            isChecked: e.target.checked*/
            type: ACTIONS.CHECK_CHANGE,
            name: e.target.name,
            value: e.target.value,
            checked: e.target.checked,
            disabled: e.target.disabled
        })
    }

    const handleInputTelChange = (value, data, event, formattedValue, dispatch) => {
        //console.log(value);
        //console.log(data);
        //console.log(event);
        //console.log(formattedValue);
        //console.log("print out the tel input change", data);
        dispatch({
            type: 'phone-change',
            value: formattedValue,
            name: event.target.id
        });
    }

    var getHasGroups = function () {
        //console.log(props);
        if (isInObject("hasGroups", props)) {
            return props.hasGroups;
        }
        else {
            return false;
        }
    }

    const [showHidePasswordFlag, setShowHidePasswordFlag] = useState(false);
    const showHidePassword = () => {
        setShowHidePasswordFlag(!showHidePasswordFlag);
    }

    var formInput = null;

    //console.log("FIELDDATAPRINT");
    //console.log(fieldData);
    //console.log(fieldD);
    //if(showInputField(fieldData.hideFieldOrgTypes, orgType)){
    //console.log(f.horizontalForm);
    switch (fieldData.type) {
        case 'file':
            //console.log("text");
            //console.log(fieldData);
            formInput = () => {
                return (
                    <>
                        <Form.Control
                            type={fieldData.type}
                            name={fieldData.name}
                            //value={fieldData.value}
                            placeholder={fieldData.display.placeholder}
                            //title={fieldData.display.title}
                            onChange={(e) => handleInputFileChange(inputDispatch, e)}
                            isInvalid={fieldData.validation.isInvalid ? "invalid" : ""}
                            isValid={fieldData.validation.isValid ? "valid" : ""}
                            readOnly={getVarValue(fieldData.readOnly) ? 'readOnly' : ''}
                            disabled={getVarValue(fieldData.disabled) ? 'disabled' : ''}
                            accept={fieldData.acceptFormats}
                            //files={[...fieldData.files]}
                            maxLength={fieldData.display.maxLength}
                            //inputMode={props.inputmode} 
                            //pattern={props.pattern} 
                            ref={fieldData.InputRef}
                        />
                        <Form.Text className="text-muted">
                            {getVarValue(fieldData.display.description)}
                        </Form.Text>
                        <Form.Control.Feedback type="invalid">
                            {displayErrors(fieldData.name, fieldData.validation.errors)}
                        </Form.Control.Feedback>
                        <Form.Control.Feedback type="valid">
                            {displaySuccessMessages(fieldData)}
                        </Form.Control.Feedback>
                    </>
                )
            }
            break;
        case 'text':
            //console.log("text");
            //console.log(fieldData);
            formInput = () => {
                return (
                    <>
                        <Form.Control
                            type={fieldData.type}
                            name={fieldData.name}
                            value={fieldData.value}
                            placeholder={fieldData.display.placeholder}
                            //title={fieldData.display.title}
                            onChange={(e) => handleInputTextChange(inputDispatch, e, getPattern())}
                            isInvalid={fieldData.validation.isInvalid ? "invalid" : ""}
                            isValid={fieldData.validation.isValid ? "valid" : ""}
                            readOnly={getVarValue(fieldData.readOnly) ? 'readOnly' : ''}
                            disabled={getVarValue(fieldData.disabled) ? 'disabled' : ''}


                            maxLength={fieldData.display.maxLength}
                            //inputMode={props.inputmode} 
                            //pattern={props.pattern} 
                            ref={fieldData.InputRef}
                        />
                        <Form.Text className="text-muted">
                            {getVarValue(fieldData.display.description)}
                        </Form.Text>
                        <Form.Control.Feedback className={fieldData.validation.isInvalid ? "is-invalid" : ""} type="invalid">
                            {displayErrors(fieldData.name, fieldData.validation.errors)}
                        </Form.Control.Feedback>
                        <Form.Control.Feedback type="valid">
                            {displaySuccessMessages(fieldData)}
                        </Form.Control.Feedback>
                    </>
                )
            }
            break;
        case 'plain':
            
            formInput = () => {
                return (
                    <>
                        
                        <p className={getClasses()!=null ? getClasses() : ""}>{fieldData.value}</p>
                        
                        <Form.Text className="text-muted">
                            {getVarValue(fieldData.display.description)}
                        </Form.Text>
                        
                    </>
                )
            }
            break;
        case 'textarea':
            //console.log("text");
            //console.log(fieldData);
            formInput = () => {
                

                return (
                    <>
                        <Form.Control
                            as="textarea"
                            rows={fieldData.display.rows}


                            type={fieldData.type}
                            name={fieldData.name}
                            value={fieldData.value}
                            placeholder={fieldData.display.placeholder}

                            //title={fieldData.display.title}
                            onChange={(e) => handleInputTextAreaChange(inputDispatch, e, getPattern())}
                            isInvalid={fieldData.validation.isInvalid ? "invalid" : ""}
                            isValid={fieldData.validation.isValid ? "valid" : ""}
                            readOnly={getVarValue(fieldData.readOnly) ? 'readOnly' : ''}
                            disabled={getVarValue(fieldData.disabled) ? 'disabled' : ''}


                            maxlength={fieldData.display.maxLength}
                            //inputMode={props.inputmode} 
                            //pattern={props.pattern} 
                            ref={fieldData.InputRef}
                        />
                        {

                            <Form.Text className="d-flex justify-content-end mt-0 lh-sm">
                                {fieldData.count}/{fieldData.display.maxLength}
                            </Form.Text>

                        }
                        <Form.Text className="text-muted">
                            {getVarValue(fieldData.display.description)}
                        </Form.Text>
                        
                        <Form.Control.Feedback className={fieldData.validation.isInvalid ? "is-invalid" : ""} type="invalid">
                            {displayErrors(fieldData.name, fieldData.validation.errors)}
                        </Form.Control.Feedback>
                        <Form.Control.Feedback type="valid">
                            {displaySuccessMessages(fieldData)}
                        </Form.Control.Feedback>
                    </>
                )
            }
            break;
        case 'number':
            //console.log("text");
            //console.log(fieldData);
            formInput = () => {
                return (
                    <>
                        <Form.Control
                            type={fieldData.type}
                            name={fieldData.name}
                            value={trimNumber(fieldData.value, fieldData.display.maxLength, fieldData.display.maxValue, fieldData.display.minValue)}
                            placeholder={fieldData.display.placeholder}
                            //title={fieldData.display.title}
                            onChange={(e) => handleInputTextChange(inputDispatch, e, getPattern())}
                            onBlur={(e) => handleInputTextChange(inputDispatch, e, getPattern())}
                            isInvalid={getVarValue(fieldData.validation.isInvalid) ? "invalid" : ""}
                            isValid={getVarValue(fieldData.validation.isValid) ? "valid" : ""}
                            readOnly={getVarValue(fieldData.readOnly) ? 'readOnly' : ''}
                            disabled={getVarValue(fieldData.disabled) ? 'disabled' : ''}
                        

                            maxLength={fieldData.display.maxLength}
                            //inputMode={props.inputmode} 
                            //pattern={props.pattern} 
                            ref={fieldData.InputRef}
                        />
                        <Form.Text className="text-muted">
                            {getVarValue(fieldData.display.description)}
                        </Form.Text>
                        <Form.Control.Feedback type="invalid">
                            {displayErrors(fieldData.name, fieldData.validation.errors)}
                        </Form.Control.Feedback>
                        <Form.Control.Feedback type="valid">
                            {displaySuccessMessages(fieldData)}
                        </Form.Control.Feedback>
                    </>
                )
            }
            break;
    
        case 'date':
            //console.log("date");
            //console.log(fieldData);
            formInput = () => {
                return (
                    <>
                        <Form.Control
                            type={fieldData.type}
                            name={fieldData.name}
                            value={fieldData.value}
                            placeholder={fieldData.display.placeholder}
                            //title={fieldData.display.title}
                            onChange={(e) => handleInputDateChange(inputDispatch, e)}
                            isInvalid={fieldData.validation.isInvalid ? "invalid" : ""}
                            isValid={fieldData.validation.isValid ? "valid" : ""}
                            readOnly={getVarValue(fieldData.readOnly) ? 'readOnly' : ''}
                            disabled={getVarValue(fieldData.disabled) ? 'disabled' : ''}
                            className={getVarValue(fieldData.disabled) && (fieldData.value == null || fieldData.value == "")
                                ? "hide-text"
                                : ""
                            }
                            /*autoComplete={f.autoComplete}
                            list={f.list}
                            maxLength={f.maxLength}
                            minLength={f.minLength}
                            pattern={f.pattern}
                            size={f.size}
                            spellcheck={f.spellcheck}*/
                            ref={fieldData.InputRef}
                        />
                        <Form.Text className="text-muted">
                            {getVarValue(fieldData.display.description)}
                        </Form.Text>
                        <Form.Control.Feedback type="invalid">
                            {displayErrors(fieldData.name, fieldData.validation.errors)}
                        </Form.Control.Feedback>
                        <Form.Control.Feedback type="valid">
                            {displaySuccessMessages(fieldData)}
                        </Form.Control.Feedback>
                    </>
                )
            }
            break;
        case 'select':
            //console.log("select");
            //console.log(fieldData);

            
            
            formInput = () => {
                const renderOptions = (options, groupId) => {
                    //console.log(options);

                    const list = options.filter(o => o.group==groupId);

                    return list.map(v => {
                        return (
                            <option key={fieldData.id + "_" + v.index + "_" + groupId} value={v.value+":"+groupId} /*title={v.title}*/ selected={v.isSelected}>{v.displayValue}</option>
                        );
                    });
                };
                return (
                    <>
                        <Form.Select
                            name={fieldData.name}
                            onChange={(e) => handleInputSelectChange(inputDispatch, e)}
                            isInvalid={fieldData.validation.isInvalid ? "invalid" : ""}
                            isValid={fieldData.validation.isValid ? "valid" : ""}
                            readOnly={getVarValue(fieldData.readOnly) ? 'readOnly' : ''}
                            disabled={getVarValue(fieldData.disabled) ? 'disabled' : ''}

                            /*autoComplete={f.autoComplete}
                            autoFocus={f.autoFocus}
                            form={f.form}
                            multiple={f.multiple}
                            size={f.size}*/

                            ref={fieldData.InputRef}
                        >
                            {
                                getHasGroups() != true 
                                ?   
                                    fieldData.options.map((v) =>
                                        <option key={fieldData.name + "_" + v.index} value={v.value} /*title={v.title}*/ selected={v.isSelected}>{v.displayValue}</option>
                                    )

                                :   
                                    <>
                                        {renderOptions(fieldData.options, 0)}
                                        
                                        {fieldData.optGroups.map((g)=>{
                                            return (   
                                                <optgroup label={g.name}>
                                                    {
                                                        renderOptions(fieldData.options, g.id)
                                                    }
                                                </optgroup>
                                            );
                                        })}
                                    </>
                                    
                                    
                                    
                            }
                        </Form.Select>
                        <Form.Text className="text-muted">
                            {getVarValue(fieldData.display.description)}
                        </Form.Text>
                        <Form.Control.Feedback type="invalid">
                            {displayErrors(fieldData.name, fieldData.validation.errors)}
                        </Form.Control.Feedback>
                        <Form.Control.Feedback type="valid">
                            {displaySuccessMessages(fieldData)}
                        </Form.Control.Feedback>


                    </>
                )
            }
            break;
        case 'radio':
            //console.log("radio");
            //console.log(fieldData);
            formInput = () => {
                return (
                    <>

                        {
                            fieldData.radioButtons.map((v) =>
                                <Form.Check
                                    key={fieldData.name + "_" + v.id}
                                    type="radio"
                                    id={v.id + "-" +  fieldData.name}
                                    inline={fieldData.display.inline!=null ? fieldData.display.inline : true}
                                    //title={v.title}
                                    label={v.label}
                                    name={v.name}
                                    value={v.value}
                                    onChange={(e) => handleInputRadioChange(inputDispatch, e)}
                                    checked={v.isChecked}
                                    isInvalid={fieldData.validation.isInvalid ? "invalid" : ""}
                                    isValid={fieldData.validation.isValid ? "valid" : ""}
                                    //readOnly={getVarValue(v.readOnly) ? 'readOnly' : ''}
                                    disabled={getVarValue(v.disabled) ? 'disabled' : ''}
                                    //aria-label="test"

                                    ref={fieldData.InputRef}
                                />
                            )
                        }
                        <Form.Text className="text-muted">
                            {getVarValue(fieldData.display.description)}
                        </Form.Text>
                        <Form.Control.Feedback className={fieldData.validation.isInvalid ? "is-invalid" : ""} type="invalid">
                            {displayErrors(fieldData.name, fieldData.validation.errors)}
                        </Form.Control.Feedback>
                        <Form.Control.Feedback className={fieldData.validation.isValid ? "is-valid" : ""} type="valid">
                            {displaySuccessMessages(fieldData)}
                        </Form.Control.Feedback>

                    </>
                )
            }
            break;



        case 'checkbox':
            //console.log("checkbox");
            //console.log(fieldData);
            var disabled = function (ind, all) {
                if (all == true) {
                    return true;
                }
                else {
                    return ind;
                }
            }
            formInput = () => {
                //console.log(getFormFieldAlignment().displayName);
                return (
                    <>

                        {
                            fieldData.checkBoxes.map((v, index) =>
                                <Form.Check
                                    key={fieldData.name + "_" + v.id}
                                    type="checkbox"
                                    id={v.id + "-" +  fieldData.name}
                                    inline={fieldData.display.inline!=null ? fieldData.display.inline : true}
                                    //title={v.title}
                                    label={v.label}
                                    name={v.name}
                                    value={v.value}
                                    onChange={(e) => handleInputCheckChange(inputDispatch, e)}
                                    checked={v.isChecked}
                                    isInvalid={fieldData.validation.isInvalid ? "invalid" : ""}
                                    isValid={fieldData.validation.isValid ? "valid" : ""}
                                    disabled={disabled(v.disabled, fieldData.disabled)}//v.disabled ? true : false}
                                    ref={fieldData.InputRef}
                                    className={index > 0 ? "mt-2" : ""}
                                />
                            )
                        }
                        <Form.Text className="text-muted">
                            {getVarValue(fieldData.display.description)}
                        </Form.Text>
                        <Form.Control.Feedback className={fieldData.validation.isInvalid ? "is-invalid" : ""} type="invalid">
                            {displayErrors(fieldData.name, fieldData.validation.errors)}
                        </Form.Control.Feedback>
                        <Form.Control.Feedback className={fieldData.validation.isValid ? "is-valid" : ""} type="valid">
                            {displaySuccessMessages(fieldData)}
                        </Form.Control.Feedback>


                    </>
                );
            };
            break;
        case 'password':
            formInput = () => {
                return (
                    <>
                        {hideLabel==true?<Form.Label htmlFor="passwordField" className="visually-hidden">Password</Form.Label>:null}
                        <InputGroup >
                            <Form.Control
                                id={fieldData.name}
                                //type={fieldData.type}
                                // type={fieldData.type}
                                type={showHidePasswordFlag ? "text" : "password"}
                                name={fieldData.name}
                                value={fieldData.value}
                                placeholder={fieldData.display.placeholder}
                                //title={fieldData.display.title}
                                onChange={(e) => handleInputTextChange(inputDispatch, e)}
                                isInvalid={fieldData.validation.isInvalid ? "invalid" : ""}
                                isValid={fieldData.validation.isValid ? "valid" : ""}
                                readOnly={getVarValue(fieldData.readOnly) ? 'readOnly' : ''}
                                disabled={getVarValue(fieldData.disabled) ? 'disabled' : ''}

                                /*autoComplete={f.autoComplete}
                                list={f.list}
                                maxLength={f.maxLength}
                                minLength={f.minLength}
                                pattern={f.pattern}
                                size={f.size}
                                spellcheck={f.spellcheck}*/
                                ref={fieldData.InputRef}
                            />
                            <Button
                                id="showPassword"
                                onClick={showHidePassword}
                                className="smallText"
                            >
                                {showHidePasswordFlag ? "Hide" : "Show"}
                            </Button>
                            <Form.Text className="text-muted">
                                {getVarValue(fieldData.display.description)}
                            </Form.Text>
                            <Form.Control.Feedback type="invalid">
                                {displayErrors(fieldData.name, fieldData.validation.errors)}
                            </Form.Control.Feedback>
                            <Form.Control.Feedback type="valid">
                                {displaySuccessMessages(fieldData)}
                            </Form.Control.Feedback>
                        </InputGroup>
                    </>
                    /*<Form.Group as={getFormFieldAlignment()} className="mb-3" controlId={fieldD.name}>
                        {f.functions.displayLabelFunc(f.fieldName, f.hideLabel, getColLabelSizes, getFormFieldAlignment())}
                        <Col
                            xs={getColSize("inputCols",'xs')} 
                            sm={getColSize("inputCols",'sm')} 
                            md={getColSize("inputCols",'md')} 
                            lg={getColSize("inputCols",'lg')} 
                            xl={getColSize("inputCols",'xl')} 
                            xxl={getColSize("inputCols",'xxl')} 
                        >
                            <Form.Control
                                type={fieldD.type}
                                name={fieldD.name}
                                value={d.value}
                                placeholder={fieldD.display.placeholder}
                                title={fieldD.display.title}
                                onChange={d.onChange}
                                isInvalid={d.validation.isInvalid ? "invalid":""}
                                readOnly={getVarValue(d.readOnly) ? 'readOnly' : ''}
                                disabled={d.disabled ? 'disabled' : ''}

                                autoComplete={f.autoComplete}
                                list={f.list}
                                maxLength={f.maxLength}
                                minLength={f.minLength}
                                pattern={f.pattern}
                                size={f.size}
                                spellcheck={f.spellcheck}
                                ref={fieldD.InputRef}
                            />
                            <Form.Text className="text-muted">
                                {getVarValue(fieldD.display.description)}
                            </Form.Text>
                            <Form.Control.Feedback type="invalid">
                                {f.functions.displayErrorsFunc(f.fieldName)}
                            </Form.Control.Feedback>
                        </Col>
                    </Form.Group>*/
                )
            }
            break;
        case 'tel':
            //console.log("tel");
            //console.log(fieldData);
            formInput = () => {
                return (
                    <>
                        <PhoneInput
                            defaultMask="(...) ...-...."
                            alwaysDefaultMask="true"
                            country={"us"}
                            autoFormat="true"
                            enableAreaCodes="true"
                            disableCountryCode="true"
                            disableDropdown="true"
                            disableSearchIcon="true"
                            disableCountryGuess="true"
                            buttonStyle={{ display: 'none' }}
                            value={fieldData.value}
                            //dispatch,e, formattedValue
                            onChange={(value, data, event, formattedValue) => handleInputTelChange(value, data, event, formattedValue, inputDispatch)}
                            //onChange={(event, formattedValue) => handleInputTelChange(inputDispatch, event, formattedValue)} 
                            placeholder={fieldData.display.placeholder}
                            title={fieldData.display.title}
                            inputProps={{
                                type: "tel",
                                id: fieldData.name,
                                name: fieldData.name,
                                //title: fieldData.display.title,
                                //isInvalid: d.validation.isInvalid==null || d.validation.isInvalid ? "invalid":"",
                                className: fieldData.validation.isInvalid ? "form-control is-invalid" : fieldData.validation.isValid ? "form-control is-valid" : "form-control",
                                readOnly: getVarValue(fieldData.readOnly) ? 'readOnly' : '',
                                disabled: getVarValue(fieldData.disabled) ? 'disabled' : '',

                                /*autoComplete:f.autoComplete,
                                list:f.list,
                                maxLength:f.maxLength,
                                minLength:f.minLength,
                                pattern:f.pattern,
                                size:f.size,
                                spellcheck:f.spellcheck,*/
                                ref: fieldData.InputRef
                            }}
                        />
                        <Form.Text className="text-muted">
                            {getVarValue(fieldData.display.description)}
                        </Form.Text>
                        <Form.Control.Feedback className={fieldData.validation.isInvalid ? "is-invalid" : ""} type="invalid">
                            {displayErrors(fieldData.name, fieldData.validation.errors)}
                        </Form.Control.Feedback>
                        <Form.Control.Feedback className={fieldData.validation.isValid ? "is-valid" : ""} type="valid">
                            {displaySuccessMessages(fieldData)}
                        </Form.Control.Feedback>
                    </>
                );
            }
            break;
        default:
            formInput = () => {
                return (
                    <>
                        <p>{"NONE"}</p>
                    </>
                )
            };
            break;
    }
    //}
    //else {
    //    return null;
    //}

    return (

        fieldData.type == "radio" || fieldData.type == "checkbox"
            ? <fieldset>
                <Form.Group as={getFormFieldAlignment()} className={getRowClasses()!=null ? getRowClasses() : "mb-3"} controlId={fieldData.id}>

                    {displayLabel(fieldData, hideLabel, getColLabelSizes, getFormFieldAlignment(), true)}
                    <Col
                        xs={getColSize("inputCols", 'xs')}
                        sm={getColSize("inputCols", 'sm')}
                        md={getColSize("inputCols", 'md')}
                        lg={getColSize("inputCols", 'lg')}
                        xl={getColSize("inputCols", 'xl')}
                        xxl={getColSize("inputCols", 'xxl')}
                    >
                        {formInput()}
                    </Col>

                </Form.Group></fieldset>

            : <Form.Group as={getFormFieldAlignment()} className={getRowClasses()!=null ? getRowClasses() : "mb-3"} controlId={fieldData.id}>
                {displayLabel(fieldData, hideLabel, getColLabelSizes, getFormFieldAlignment())}
                <Col
                    xs={getColSize("inputCols", 'xs')}
                    sm={getColSize("inputCols", 'sm')}
                    md={getColSize("inputCols", 'md')}
                    lg={getColSize("inputCols", 'lg')}
                    xl={getColSize("inputCols", 'xl')}
                    xxl={getColSize("inputCols", 'xxl')}
                >
                    {formInput()}
                </Col>
            </Form.Group>


    );
}
